import { navigateTo, reloadPage } from "@sg-protect/core";
import { REGION_URL_SEARCH_PARAM, type Region } from "@sg-protect/runtime-config";

// Null reloads with no region, so the default applies.
export function reloadInRegion(region: Region | null) {
    const url = new URL(window.location.href);
    // Boot writes ?region= back into storage, so a stale one would undo the switch and reload again.
    if (region === null) {
        url.searchParams.delete(REGION_URL_SEARCH_PARAM);
    } else {
        url.searchParams.set(REGION_URL_SEARCH_PARAM, region);
    }

    // Replacing with the same URL only scrolls to its #hash instead of reloading.
    if (url.href === window.location.href) {
        reloadPage();
    } else {
        navigateTo(url.href, { replace: true });
    }
}
